'use client'
import { jsx } from "react/jsx-runtime";
import { IconButton } from "../../IconButton/index.js";
import { calendarVariants } from "../Calendar/Calendar.variants.js";
function PreviousMonthButton(props) {
    const { buttonPrevious, buttonPreviousContainer } = calendarVariants();
    return /*#__PURE__*/ jsx("div", {
        className: buttonPreviousContainer(),
        children: /*#__PURE__*/ jsx(IconButton, {
            ...props,
            className: buttonPrevious(),
            iconName: "chevron_left",
            type: "plainPrimary",
            size: "sm"
        })
    });
}
function NextMonthButton(props) {
    const { buttonNext, buttonNextContainer } = calendarVariants();
    return /*#__PURE__*/ jsx("div", {
        className: buttonNextContainer(),
        children: /*#__PURE__*/ jsx(IconButton, {
            ...props,
            className: buttonNext(),
            iconName: "chevron_right",
            type: "plainPrimary",
            size: "sm"
        })
    });
}
export { NextMonthButton, PreviousMonthButton };
